import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * Maps market-id (as string key) → ordered list of brand ids for that market.
 * Values may contain numeric brand ids (regular brands) or string ULIDs (brand sets).
 *
 * Note: JS object keys are always strings. Market ids arriving as numbers from
 * `userSelection.markets` must be coerced with `String()` before lookup.
 */
type BrandsOrderMapping = Record<string, (number | string)[]>;

const initialState: BrandsOrderMapping = {};

export const brandsOrderMappingSlice = createSlice({
  name: "brandsOrderMapping",
  initialState,
  reducers: {
    setBrandsMapping: (state, action: PayloadAction<BrandsOrderMapping>) => {
      return action.payload;
    },
    setBrandsMappingForMarket: (
      state,
      action: PayloadAction<{ marketId: number | string; order: (number | string)[] }>,
    ) => {
      state[String(action.payload.marketId)] = action.payload.order;
    },
  },
});

export const { setBrandsMapping, setBrandsMappingForMarket } =
  brandsOrderMappingSlice.actions;

export default brandsOrderMappingSlice.reducer;
